export default __webpack_public_path__ + "static/media/collage.7e25c546.png";